import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

export default class extends Controller {

  connect() {
    const message = document.getElementById("liveMessage")
    const toast = new Toast(message)
    toast.show();
  }
}